import { render, staticRenderFns } from "./SendError2Window.vue?vue&type=template&id=3cac6664&scoped=true"
import script from "./SendError2Window.vue?vue&type=script&lang=js"
export * from "./SendError2Window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac6664",
  null
  
)

export default component.exports